/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Art_SourceInputs */

const en_svc_rag_art_source = /** @type {(inputs: Svc_Rag_Art_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company handbook`)
};

const lv_svc_rag_art_source = /** @type {(inputs: Svc_Rag_Art_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzņēmuma rokasgrāmata`)
};

/**
* | output |
* | --- |
* | "Company handbook" |
*
* @param {Svc_Rag_Art_SourceInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_art_source = /** @type {((inputs?: Svc_Rag_Art_SourceInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Art_SourceInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_art_source(inputs)
	return en_svc_rag_art_source(inputs)
});